import styled from "styled-components"
import {Container, Typography} from "components";
import { Card } from '@material-ui/core';

export const DashboardContainer = styled(Container.Grid)``

export const DashboardCardContainer = styled(Container.Grid)`
  margin-bottom: 30px;
`
